export const cityHighlights = {
  en: {
    bogota: {
      id: 'bogota',
      title: 'Bogotá',
      description: 'A vibrant capital where culture, gastronomy and history converge. Signature culinary moments and refined cultural explorations, Bogotá reveals a sophisticated and unexpected side of Colombia.',
      highlights: [
        {
          title: 'Tejo Experience',
          image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=1000&q=80',
          text: "A private introduction to Colombia's most authentic tradition, through an exclusive tejo encounter in a curated setting. An immersive moment that blends culture, interaction and local heritage."
        },
        {
          title: 'Salt Cathedral',
          image: '/bog-catedral-zipa.webp',
          text: "A private visit to the Salt Cathedral, one of Colombia's most extraordinary landmarks. An immersive journey beneath the surface, transformed into a refined cultural experience."
        }
      ]
    },
    cartagena: {
      id: 'cartagena',
      title: 'Cartagena',
      description: 'A timeless destination where history, architecture and Caribbean charm meet. Sunset sailing along the coastline, followed by curated dining in hidden courtyards, Cartagena invites a slower, more refined way to experience Colombia.',
      highlights: [
        {
          title: 'Sunset from the Ramparts',
          image: '/ctg-atardecer.webp',
          text: "A private sunset moment on Cartagena's historic ramparts, where the Caribbean sky turns pastel over the walled city. A serene, luminous end to the day defined by heritage, calm and quiet elegance."
        },
        {
          title: 'Casa 1537',
          image: '/ctg-casa1537.jpg',
          text: 'An intimate dining moment within a hidden colonial residence, where architecture, atmosphere and refined service come together. A space designed for privacy, elegance and meaningful connection.'
        }
      ]
    },
    medellin: {
      id: 'medellin',
      title: 'Medellín',
      description: 'A city defined by innovation, design and transformation. Exclusive urban experiences paired with curated cultural encounters, Medellín offers a modern, dynamic way to experience Colombia.',
      highlights: [
        {
          title: 'Silletero Experience',
          image: '/mde-pueblito-p5.webp',
          text: "An authentic experience rooted in Colombia's floral traditions. A private encounter with local silleteros, surrounded by nature and craftsmanship, where culture, heritage and artistry are expressed in their purest form."
        },
        {
          title: 'Botanical Garden',
          image: 'https://images.unsplash.com/photo-1680209668002-924ffe3f1952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxib3RhbmljYWwlMjBnYXJkZW4lMjBNZWRlbGxpbiUyMGRpbmluZyUyMGV2ZW50JTIwbmF0dXJhbHxlbnwwfHx8fDE3ODAwNzA5MDJ8MA&ixlib=rb-4.1.0&q=85',
          text: "An intimate dining experience set within Medellín's natural landscape. A private setting surrounded by greenery, where design, nature and atmosphere merge effortlessly. A moment defined by calm, subtle detail and quiet sophistication."
        }
      ]
    },
    coffee: {
      id: 'coffee',
      title: 'Coffee Region',
      description: 'A landscape of rolling hills, lush greenery and timeless traditions. Morning rituals, slow living and deep connection to origin. A more grounded and sensory way to experience Colombia.',
      highlights: [
        {
          title: 'Finca El Cabrero Experience',
          image: 'https://images.pexels.com/photos/13802102/pexels-photo-13802102.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: "A private coffee encounter set within a working finca. From handpicking to tasting, each moment reveals the process behind Colombia's most iconic tradition. A journey defined by craft, precision and sensory depth."
        },
        {
          title: 'Hacienda Stay',
          image: 'https://images.unsplash.com/photo-1774984449677-116a1e3ae405?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxDb2xvbWJpYW4lMjBjb2ZmZWUlMjBoYWNpZW5kYSUyMGJvdXRpcXVlJTIwaG90ZWwlMjBjb2xvbmlhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODAwNzA5MTJ8MA&ixlib=rb-4.1.0&q=85',
          text: 'An exclusive stay within a boutique hacienda surrounded by nature. Soft mornings, curated details and a slower rhythm of travel, creating a calm and elevated environment for rest, connection and quiet luxury.'
        }
      ]
    },
    cali: {
      id: 'cali',
      title: 'Cali',
      description: 'A city where rhythm, culture and authenticity come to life. Intimate dance encounters and carefully designed cultural moments, Cali offers a vibrant, immersive way to experience Colombia.',
      highlights: [
        {
          title: 'Salsa Experience',
          image: '/clo-salsa.webp',
          text: "An intimate dance experience, guided by local experts. A carefully curated encounter with Colombia's rhythm and culture, where movement becomes connection and authenticity takes center stage."
        },
        {
          title: 'Orquideorama',
          image: 'https://images.unsplash.com/photo-1599543359278-76676745f1e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxvcnF1aWRlb3JhbWElMjBNZWRlbGxpbiUyMGJvdGFuaWNhbCUyMGdhcmRlbiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODAwNzA5MTJ8MA&ixlib=rb-4.1.0&q=85',
          text: 'A refined space for shared moments. Where design, nature and atmosphere come together effortlessly, creating an environment defined by privacy, intention and quiet elegance.'
        }
      ]
    },
    orinoquia: {
      id: 'orinoquia',
      title: 'Orinoquía',
      description: 'The vast eastern plains of Colombia, where endless horizons meet living tradition. Golden sunsets over the llanos, llanero horsemanship and rustic cattle ranches, the Orinoquía offers an untamed, soulful side of Colombia.',
      highlights: [
        {
          title: 'Llanero Sunset Ride',
          image: 'https://images.pexels.com/photos/572861/pexels-photo-572861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: "A private horseback journey through the open savanna at golden hour, guided by traditional llaneros. A grounded encounter with Colombia's cowboy heritage, where silence, space and craft merge into one moment."
        },
        {
          title: 'Hato Retreat',
          image: 'https://images.pexels.com/photos/1687067/pexels-photo-1687067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'An exclusive stay at a working hato, where ancestral ranch life meets refined hospitality. Slow mornings, native wildlife encounters and open-fire dining under a sky of countless stars.'
        }
      ]
    },
    amazonia: {
      id: 'amazonia',
      title: 'Amazonía',
      description: 'The pulse of the rainforest, where every sound and shadow tells a story. Private navigations along ancient rivers and encounters with indigenous communities, the Colombian Amazon reveals depth, mystery and living heritage.',
      highlights: [
        {
          title: 'River Expedition',
          image: 'https://images.pexels.com/photos/975771/pexels-photo-975771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'A private expedition through hidden Amazonian tributaries, guided by local naturalists. A sensory immersion into the largest rainforest on Earth, where every meander opens onto a new discovery.'
        },
        {
          title: 'Indigenous Encounter',
          image: 'https://images.pexels.com/photos/1112048/pexels-photo-1112048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'A respectful, curated visit with an indigenous community, where ancestral knowledge, ritual and craft are shared with intention. A rare moment of human connection at the heart of the jungle.'
        }
      ]
    }
  },
  es: {
    bogota: {
      id: 'bogota',
      title: 'Bogotá',
      description: 'Una capital vibrante donde convergen cultura, gastronomía e historia. Momentos culinarios únicos y exploraciones culturales refinadas, Bogotá revela un lado sofisticado e inesperado de Colombia.',
      highlights: [
        {
          title: 'Experiencia de Tejo',
          image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=1000&q=80',
          text: 'Una introducción privada a la tradición más auténtica de Colombia, a través de un encuentro exclusivo de tejo en un entorno curado. Un momento inmersivo que combina cultura, interacción y patrimonio local.'
        },
        {
          title: 'Catedral de Sal',
          image: '/bog-catedral-zipa.webp',
          text: 'Una visita privada a la Catedral de Sal, uno de los lugares más extraordinarios de Colombia. Un viaje inmersivo bajo la superficie, transformado en una experiencia cultural refinada.'
        }
      ]
    },
    cartagena: {
      id: 'cartagena',
      title: 'Cartagena',
      description: 'Un destino atemporal donde se encuentran historia, arquitectura y encanto caribeño. Navegación al atardecer por la costa, seguida de cenas curadas en patios escondidos, Cartagena invita a una forma más lenta y refinada de experimentar Colombia.',
      highlights: [
        {
          title: 'Atardecer en las Murallas',
          image: '/ctg-atardecer.webp',
          text: 'Un momento privado al atardecer sobre las murallas históricas de Cartagena, mientras el cielo del Caribe se tiñe de pasteles sobre la ciudad amurallada. Un cierre luminoso y sereno marcado por el patrimonio, la calma y la elegancia silenciosa.'
        },
        {
          title: 'Casa 1537',
          image: '/ctg-casa1537.jpg',
          text: 'Un momento íntimo de cena dentro de una residencia colonial escondida, donde la arquitectura, la atmósfera y el servicio refinado se unen. Un espacio diseñado para la privacidad, la elegancia y la conexión significativa.'
        }
      ]
    },
    medellin: {
      id: 'medellin',
      title: 'Medellín',
      description: 'Una ciudad definida por la innovación, el diseño y la transformación. Experiencias urbanas exclusivas combinadas con encuentros culturales curados, Medellín ofrece una forma moderna y dinámica de experimentar Colombia.',
      highlights: [
        {
          title: 'Experiencia Silletera',
          image: '/mde-pueblito-p5.webp',
          text: 'Una experiencia auténtica arraigada en las tradiciones florales de Colombia. Un encuentro privado con silleteros locales, rodeados de naturaleza y artesanía, donde la cultura, el patrimonio y el arte se expresan en su forma más pura.'
        },
        {
          title: 'Jardín Botánico',
          image: 'https://images.unsplash.com/photo-1680209668002-924ffe3f1952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxib3RhbmljYWwlMjBnYXJkZW4lMjBNZWRlbGxpbiUyMGRpbmluZyUyMGV2ZW50JTIwbmF0dXJhbHxlbnwwfHx8fDE3ODAwNzA5MDJ8MA&ixlib=rb-4.1.0&q=85',
          text: 'Una experiencia íntima de cena enmarcada en el paisaje natural de Medellín. Un escenario privado rodeado de vegetación, donde el diseño, la naturaleza y la atmósfera se fusionan sin esfuerzo. Un momento definido por la calma, el detalle sutil y la sofisticación tranquila.'
        }
      ]
    },
    coffee: {
      id: 'coffee',
      title: 'Región Cafetera',
      description: 'Un paisaje de colinas onduladas, vegetación exuberante y tradiciones atemporales. Rituales matutinos, vida lenta y conexión profunda con el origen. Una forma más arraigada y sensorial de experimentar Colombia.',
      highlights: [
        {
          title: 'Experiencia en Finca El Cabrero',
          image: 'https://images.pexels.com/photos/13802102/pexels-photo-13802102.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'Un encuentro privado con el café en una finca activa. Desde la recolección manual hasta la cata, cada momento revela el proceso detrás de la tradición más icónica de Colombia. Un viaje definido por el oficio, la precisión y la profundidad sensorial.'
        },
        {
          title: 'Estadía en Hacienda',
          image: 'https://images.unsplash.com/photo-1774984449677-116a1e3ae405?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxDb2xvbWJpYW4lMjBjb2ZmZWUlMjBoYWNpZW5kYSUyMGJvdXRpcXVlJTIwaG90ZWwlMjBjb2xvbmlhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODAwNzA5MTJ8MA&ixlib=rb-4.1.0&q=85',
          text: 'Una estadía exclusiva en una hacienda boutique rodeada de naturaleza. Mañanas suaves, detalles curados y un ritmo de viaje más pausado, creando un entorno tranquilo y elevado para el descanso, la conexión y el lujo silencioso.'
        }
      ]
    },
    cali: {
      id: 'cali',
      title: 'Cali',
      description: 'Una ciudad donde el ritmo, la cultura y la autenticidad cobran vida. Encuentros íntimos de baile y momentos culturales cuidadosamente diseñados, Cali ofrece una forma vibrante e inmersiva de experimentar Colombia.',
      highlights: [
        {
          title: 'Experiencia de Salsa',
          image: '/clo-salsa.webp',
          text: 'Una experiencia íntima de baile, guiada por expertos locales. Un encuentro cuidadosamente curado con el ritmo y la cultura de Colombia, donde el movimiento se convierte en conexión y la autenticidad toma el escenario principal.'
        },
        {
          title: 'Orquideorama',
          image: 'https://images.unsplash.com/photo-1599543359278-76676745f1e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxvcnF1aWRlb3JhbWElMjBNZWRlbGxpbiUyMGJvdGFuaWNhbCUyMGdhcmRlbiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODAwNzA5MTJ8MA&ixlib=rb-4.1.0&q=85',
          text: 'Un espacio refinado para momentos compartidos. Donde el diseño, la naturaleza y la atmósfera se unen sin esfuerzo, creando un entorno definido por la privacidad, la intención y la elegancia silenciosa.'
        }
      ]
    },
    orinoquia: {
      id: 'orinoquia',
      title: 'Orinoquía',
      description: 'Los vastos llanos orientales de Colombia, donde el horizonte se funde con la tradición viva. Atardeceres dorados sobre la sabana, jinetes llaneros y hatos ancestrales, la Orinoquía revela un lado indómito y profundamente auténtico de Colombia.',
      highlights: [
        {
          title: 'Cabalgata Llanera al Atardecer',
          image: 'https://images.pexels.com/photos/572861/pexels-photo-572861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'Un recorrido privado a caballo por la sabana abierta a la hora dorada, guiado por llaneros tradicionales. Un encuentro genuino con el patrimonio vaquero colombiano, donde el silencio, el espacio y el oficio se convierten en un solo momento.'
        },
        {
          title: 'Retiro en Hato',
          image: 'https://images.pexels.com/photos/1687067/pexels-photo-1687067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'Una estadía exclusiva en un hato en funcionamiento, donde la vida ancestral se une a una hospitalidad refinada. Mañanas pausadas, encuentros con la fauna nativa y cenas al fuego bajo un cielo colmado de estrellas.'
        }
      ]
    },
    amazonia: {
      id: 'amazonia',
      title: 'Amazonía',
      description: 'El pulso de la selva, donde cada sonido y cada sombra cuentan una historia. Navegaciones privadas por ríos ancestrales y encuentros con comunidades indígenas, la Amazonía colombiana revela profundidad, misterio y patrimonio vivo.',
      highlights: [
        {
          title: 'Expedición Fluvial',
          image: 'https://images.pexels.com/photos/975771/pexels-photo-975771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'Una expedición privada por afluentes ocultos de la Amazonía, guiada por naturalistas locales. Una inmersión sensorial en la selva más grande del planeta, donde cada meandro revela un nuevo descubrimiento.'
        },
        {
          title: 'Encuentro Indígena',
          image: 'https://images.pexels.com/photos/1112048/pexels-photo-1112048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
          text: 'Una visita curada y respetuosa a una comunidad indígena, donde el conocimiento ancestral, el ritual y la artesanía se comparten con intención. Un momento excepcional de conexión humana en el corazón de la selva.'
        }
      ]
    }
  }
};
